<!--
 * @Description:
 * @Autor: Zhongyu
 * @Date: 2022-01-26 11:51:02
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-02-16 10:44:24
-->
<template>
  <div class="box" :style="{ width: `${sWidth}px`, height: `${sHeight}px` }">
    <div class="box-bg">
      <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
        <g id="Layer_1">
          <path
            :d="d"
            stroke="#16869e"
            fill="rgba(9, 25, 40, 0.8)"
            stroke-width="2"
          ></path>

          <line
            :x1="angle"
            y1="0"
            :x2="(45 / 1920) * screenWidth"
            y2="0"
            style="stroke:rgb(10, 184, 239);stroke-width:2"
          />
          <line
            :x1="angle"
            y1="0"
            x2="0"
            :y2="angle"
            style="stroke:rgb(10, 184, 239);stroke-width:2"
          />

          <line
            :x1="sWidth - 3 * angle"
            y1="0"
            :x2="sWidth - angle"
            y2="0"
            style="stroke:rgb(10, 184, 239);stroke-width:2"
          />
          <line
            :x1="sWidth - angle"
            y1="0"
            :x2="sWidth"
            :y2="angle"
            style="stroke:rgb(10, 184, 239);stroke-width:2"
          />

          <line
            :x1="sWidth"
            :y1="(30 / 1920) * screenWidth"
            :x2="sWidth"
            :y2="sHeight - (180 / 1920) * screenWidth"
            style="stroke:rgb(10, 184, 239);stroke-width:2"
          />
          <line
            :x1="sWidth"
            :y1="sHeight - (100 / 1920) * screenWidth"
            :x2="sWidth"
            :y2="sHeight - angle"
            style="stroke:rgb(10, 184, 239);stroke-width:2"
          />
          <line
            :x1="sWidth"
            :y1="sHeight - angle"
            :x2="sWidth - angle"
            :y2="sHeight"
            style="stroke:rgb(10, 184, 239);stroke-width:2"
          />
          <line
            :x1="sWidth - angle"
            :y1="sHeight"
            :x2="sWidth - 3 * angle"
            :y2="sHeight"
            style="stroke:rgb(10, 184, 239);stroke-width:2"
          />

          <line
            x1="0"
            :y1="(30 / 1920) * screenWidth"
            x2="0"
            :y2="sHeight - (180 / 1920) * screenWidth"
            style="stroke:rgb(10, 184, 239);stroke-width:2"
          />
          <line
            :x1="0"
            :y1="sHeight - (100 / 1920) * screenWidth"
            :x2="0"
            :y2="sHeight - angle"
            style="stroke:rgb(10, 184, 239);stroke-width:2"
          />
          <line
            x1="0"
            :y1="sHeight - angle"
            :x2="angle"
            :y2="sHeight"
            style="stroke:rgb(10, 184, 239);stroke-width:2"
          />
          <line
            :x1="angle"
            :y1="sHeight"
            :x2="sWidth - 8 * angle"
            :y2="sHeight"
            style="stroke:rgb(10, 184, 239);stroke-width:2"
          />
          <!---->
        </g>
      </svg>
    </div>
    <div class="box-body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      d: "M0,15 L15,0 L225,0 L240,15 L240,225 L225,240 L15,240 L0,225 Z",
      screenWidth: document.body.clientWidth,
      angle: 0,
      sWidth: this.width,
      sHeight: this.height
    };
  },
  watch: {
    screenWidth() {
      this.initPathD();
    }
  },
  mounted() {
    this.initPathD();
    window.addEventListener(
      "resize",
      () => (this.screenWidth = document.body.clientWidth),
      false
    );
  },
  methods: {
    initPathD() {
      let screenWidth = document.body.clientWidth;
      let width = (this.width / 1920) * screenWidth;
      let height = (this.height / 1920) * screenWidth;
      let angle = (15 / 1920) * screenWidth;
      this.angle = angle;
      this.sWidth = width;
      this.sHeight = height;

      this.d = `M0,${angle} L${angle},0 L${width -
        angle},0 L${width},${angle} L${width},${height - angle} L${width -
        angle},${height} L${angle},${height} L0,${height - angle} Z`;
    }
  }
};
</script>

<style lang="less" scoped>
@import "./index.less";
// width: 399px;
// 	height: 378px;
// 	background-image: ;
// 	background-blend-mode: ;
// 	border: solid 3px #1bc1ff;
// 	opacity: 0.5;
</style>
